import { type IConfig } from '@cian/config/shared';

import { ITrackPageViewParams, trackPageView } from './pageview';

export const EMPTY_PAGE_VIEW_DELAY_KEY = 'serp.emptyPageViewDelay';
export const DEFAULT_EMPTY_PAGE_VIEW_DELAY = 3000;

let pendingPageView: ReturnType<typeof setTimeout> | null = null;

export function cancelPendingPageView(): void {
  if (pendingPageView !== null) {
    clearTimeout(pendingPageView);
    pendingPageView = null;
  }
}

/**
 * Пустая выдача после применения фильтров часто промежуточная: цена «до 1 ₽», пока пользователь
 * набирает «до 100 000 ₽» (автоприменение по дебаунсу, CD-290660). Такой newpage с offersQty 0
 * аналитика считает за пустую выдачу. Поэтому newpage пустой выдачи откладываем и отменяем,
 * если за это время начался новый поиск; непустую выдачу отправляем сразу.
 */
export function trackPageViewDeferringEmpty(params: ITrackPageViewParams, config: IConfig): void {
  cancelPendingPageView();

  if (Number(params.results.totalOffers) !== 0) {
    trackPageView(params, config);

    return;
  }

  const delay = config.get<number>(EMPTY_PAGE_VIEW_DELAY_KEY) ?? DEFAULT_EMPTY_PAGE_VIEW_DELAY;

  pendingPageView = setTimeout(() => {
    pendingPageView = null;
    trackPageView(params, config);
  }, delay);
}
